module.exports = __webpack_public_path__ + "static/media/notes.2b9a662b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/static/icons/notes.svg
// module id = 325
// module chunks = 0